<template>
  <div class="card maintenance-page">
    <div class="card-header">
      <h5 class="card-title">Maintenance Mode</h5>
      <hr>
    </div>
    <div class="card-body">
      <div class="field-row">
        <Checkbox label="Maintenance Mode Active" v-model="deploymentLock.isActive"/>
      </div>
      <div class="field-row">
        <label class="field-label">Maintenance Message</label>
        <input v-model="deploymentLock.message" maxlength="500" placeholder="Message shown to users on the login page"/>
      </div>
      <div class="btn-container">
        <div @click="save" class="btn btn-primary save-btn">Save</div>
      </div>
    </div>
  </div>
</template>

<script>
import SystemConfigService from '../../../services/systemConfig';

export default {
  name: 'AdminMaintenanceMode',
  data() {
    return {
      deploymentLock: {
        isActive: false,
        message: 'SmartSales is currently undergoing scheduled maintenance. We will be back shortly.',
      },
    };
  },
  mounted() {
    SystemConfigService.getDeploymentLock()
      .then(res => {
        if (res) {
          this.deploymentLock.isActive = res.isActive;
          this.deploymentLock.message = res.message || this.deploymentLock.message;
        }
      })
      .catch(err => {
        console.error('Error retrieving deployment lock:', err);
        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Error loading maintenance mode settings.', type: 'error' });
      });
  },
  methods: {
    save() {
      SystemConfigService.putDeploymentLock(this.deploymentLock)
        .then(() => {
          this.$store.dispatch('GET_ALERT_MESSAGE');
          this.$store.dispatch('ADD_NOTIFICATION', { text: 'Maintenance mode settings saved.', type: 'success' });
        })
        .catch(err => {
          console.error('Error saving deployment lock:', err);
          this.$store.dispatch('ADD_NOTIFICATION', { text: 'Error saving maintenance mode settings.', type: 'error' });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.maintenance-page {
  font-family: "Helvetica Neue", "Segoe UI", Helvetica, Verdana, sans-serif;
  font-size: 14px;
  max-width: 700px;
}

.field-row {
  margin-top: 15px;
}

.field-label {
  display: block;
  font-weight: 500;
  margin-bottom: 4px;
}

input {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 14px;
}

.btn-container {
  margin-top: 20px;
}

.save-btn {
  width: 120px;
}
</style>
